import { ImageCategory } from '@/store/slices/masterDataSlice';

/**
 * Returns image categories mapped to the inspection's database template.
 * Categories for other templates stay out of the dropdown. An inspection
 * without a template id has no template-specific categories.
 */
export function filterImageCategoriesByTemplate(
  categories: readonly ImageCategory[] | undefined,
  templateId: string | undefined
): ImageCategory[] {
  if (!templateId) {
    return [];
  }
  return (categories ?? []).filter((category) => category.templateId === templateId);
}
